import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  es: {
    translation: {
      brand: "Cascante Moto Rental",
      tagline: "San Juan del Sur · Nicaragua",
      nav: {
        home: "Inicio",
        about: "Nosotros",
        rentals: "Motos y Precios",
        mission: "Misión",
        findus: "Ubicación",
        contact: "Contacto",
        bookNow: "Reservar",
      },
      hero: {
        eyebrow: "Renta de motos · 135+ reseñas · 5 ★",
        typed: [
          "EXPLORA SAN JUAN DEL SUR",
          "DESBLOQUEA LA AVENTURA",
          "SUBE EN DOS RUEDAS",
          "DESCUBRE PLAYAS OCULTAS",
        ],
        subtitle:
          "Motos confiables, precios honestos y conocimiento local. Tu próxima aventura por la costa de Nicaragua empieza aquí.",
        bookNow: "Reservar Ahora",
        viewMotos: "Ver Motos",
        scroll: "Desliza para conducir",
      },
      proof: {
        reviews: "135+ reseñas",
        rating: "5 estrellas en Google",
        years: "Años en San Juan del Sur",
        riders: "Riders felices",
      },
      testimonials: {
        title: "Lo que dicen nuestros riders",
      },
      rentals: {
        title: "Nuestras Motos",
        subtitle: "Elige la moto perfecta para tu aventura.",
        perDay: "/ día",
        perWeek: "/ semana",
        perMonth: "/ mes",
        bestFor: "Ideal para",
        reserve: "Reservar",
        loading: "Cargando motos…",
        featured: "Moto destacada",
        viewAll: "Ver toda la flota",
      },
      about: {
        title: "Nuestra Historia",
        lead:
          "Fundada en 2017 en San Juan del Sur, nuestra renta de motos nació de gente local humilde con una profunda pasión por las motos y la aventura.",
        body:
          "Lo que comenzó como una idea sencilla — ayudar a los visitantes a moverse con más libertad — se ha convertido en un negocio de confianza para viajeros de todo el mundo. Creemos que la mejor forma de descubrir Nicaragua es sobre dos ruedas: sintiendo la brisa del océano, explorando playas escondidas y viviendo la belleza del país sin límites. Nuestra misión siempre ha sido ofrecer un servicio amable, motos confiables y experiencias inolvidables a cada cliente que nos visita.",
        feat1Title: "Desde 2017",
        feat1Body: "Más de 8 años rentando motos en San Juan del Sur.",
        feat2Title: "Familia Local",
        feat2Body: "Negocio fundado y operado por gente humilde de la zona.",
        feat3Title: "Sin Límites",
        feat3Body: "Playas escondidas, brisa del océano, libertad total.",
      },
      mission: {
        title: "Nuestra Misión",
        lead:
          "Ofrecer rentas de motos confiables, accesibles y emocionantes en San Juan del Sur, ayudando a los viajeros a explorar Nicaragua con libertad, comodidad y aventura desde 2017.",
        v1Title: "Confiables",
        v1Body:
          "Motos cuidadosamente mantenidas y revisadas antes de cada renta.",
        v2Title: "Accesibles",
        v2Body:
          "Precios honestos y claros, sin sorpresas, para todo tipo de viajero.",
        v3Title: "Emocionantes",
        v3Body:
          "Aventuras inolvidables por las playas escondidas y la costa de Nicaragua.",
      },
      findus: {
        title: "Encuéntranos",
        address: "San Juan del Sur, Rivas, Nicaragua",
        hours: "Lun – Dom · 7:00 – 19:00",
        directions: "Cómo Llegar",
      },
      contact: {
        title: "Contáctanos",
        subtitle:
          "¿Listo para rodar? Reserva tu moto o haznos cualquier pregunta.",
        name: "Nombre",
        email: "Correo",
        phone: "Teléfono / WhatsApp",
        moto: "Tipo de moto",
        start: "Fecha de inicio",
        end: "Fecha de fin",
        message: "Mensaje",
        submit: "Enviar Reserva",
        whatsappBtn: "Chatear por WhatsApp",
        success: "¡Reserva enviada! Te contactaremos pronto.",
        error: "Hubo un error. Intenta por WhatsApp.",
      },
      footer: {
        rights: "Todos los derechos reservados.",
        madeIn: "Hecho con ❤ en San Juan del Sur",
      },
    },
  },
  en: {
    translation: {
      brand: "Cascante Moto Rental",
      tagline: "San Juan del Sur · Nicaragua",
      nav: { home: "Home", about: "About", rentals: "Rentals & Pricing", mission: "Mission", findus: "Find Us", contact: "Contact", bookNow: "Book Now" },
      hero: {
        eyebrow: "Moto rental · 135+ reviews · 5 ★",
        typed: ["EXPLORE SAN JUAN DEL SUR", "UNLOCK THE ADVENTURE", "RIDE ON TWO WHEELS", "DISCOVER HIDDEN BEACHES"],
        subtitle: "Reliable bikes, honest pricing, and local know-how. Your next ride along the Nicaraguan coast starts here.",
        bookNow: "Book Now",
        viewMotos: "View Motos",
        scroll: "Scroll to ride",
      },
      proof: { reviews: "135+ reviews", rating: "5 stars on Google", years: "Years in San Juan del Sur", riders: "Happy riders" },
      testimonials: { title: "What our riders say" },
      rentals: { title: "Our Motorcycles", subtitle: "Pick the perfect bike for your adventure.", perDay: "/ day", perWeek: "/ week", perMonth: "/ month", bestFor: "Best for", reserve: "Reserve", loading: "Loading motos…", featured: "Featured ride", viewAll: "View full fleet" },
      about: {
        title: "Our Story",
        lead:
          "Founded in 2017 in San Juan del Sur, our motorcycle rental shop was created by humble local people with a deep passion for motorcycles and adventure.",
        body:
          "What started as a simple idea to help visitors move around more easily has grown into a trusted rental business for travelers from all over the world. We believe the best way to discover Nicaragua is on two wheels — feeling the ocean breeze, exploring hidden beaches, and experiencing the beauty of the country without limits. Our mission has always been to offer friendly service, dependable motorcycles, and unforgettable experiences to every customer who visits us.",
        feat1Title: "Since 2017",
        feat1Body: "8+ years renting motorbikes in San Juan del Sur.",
        feat2Title: "Local Family",
        feat2Body: "Founded and run by humble locals from the area.",
        feat3Title: "Without Limits",
        feat3Body: "Hidden beaches, ocean breeze, total freedom.",
      },
      mission: {
        title: "Our Mission",
        lead:
          "To provide reliable, affordable, and exciting motorcycle rentals in San Juan del Sur, helping travelers explore Nicaragua with freedom, comfort, and adventure since 2017.",
        v1Title: "Reliable",
        v1Body: "Carefully maintained motorcycles, checked before every rental.",
        v2Title: "Affordable",
        v2Body: "Honest, transparent prices — no surprises, for every kind of traveler.",
        v3Title: "Exciting",
        v3Body: "Unforgettable adventures through hidden beaches and the Nicaraguan coast.",
      },
      findus: { title: "Find Us", address: "San Juan del Sur, Rivas, Nicaragua", hours: "Mon – Sun · 7:00 – 19:00", directions: "Get Directions" },
      contact: {
        title: "Contact Us",
        subtitle: "Ready to ride? Book your bike or ask us anything.",
        name: "Name", email: "Email", phone: "Phone / WhatsApp", moto: "Moto type", start: "Start date", end: "End date", message: "Message",
        submit: "Send Booking", whatsappBtn: "Chat on WhatsApp",
        success: "Booking sent! We'll be in touch soon.", error: "Something went wrong. Try via WhatsApp.",
      },
      footer: { rights: "All rights reserved.", madeIn: "Made with ❤ in San Juan del Sur" },
    },
  },
  fr: {
    translation: {
      brand: "Cascante Moto Rental",
      tagline: "San Juan del Sur · Nicaragua",
      nav: { home: "Accueil", about: "À propos", rentals: "Motos & Tarifs", mission: "Mission", findus: "Nous trouver", contact: "Contact", bookNow: "Réserver" },
      hero: {
        eyebrow: "Location de motos · 135+ avis · 5 ★",
        typed: ["EXPLOREZ SAN JUAN DEL SUR", "VIVEZ L'AVENTURE", "ROULEZ À DEUX ROUES", "DÉCOUVREZ DES PLAGES CACHÉES"],
        subtitle: "Motos fiables, prix honnêtes, savoir-faire local. Votre prochaine virée sur la côte du Nicaragua commence ici.",
        bookNow: "Réserver",
        viewMotos: "Voir les motos",
        scroll: "Faites défiler pour rouler",
      },
      proof: { reviews: "135+ avis", rating: "5 étoiles sur Google", years: "Ans à San Juan del Sur", riders: "Riders satisfaits" },
      testimonials: { title: "Ce que disent nos riders" },
      rentals: { title: "Nos Motos", subtitle: "Choisissez la moto idéale pour votre aventure.", perDay: "/ jour", perWeek: "/ semaine", perMonth: "/ mois", bestFor: "Idéal pour", reserve: "Réserver", loading: "Chargement…", featured: "Moto vedette", viewAll: "Voir la flotte" },
      about: {
        title: "Notre Histoire",
        lead:
          "Fondée en 2017 à San Juan del Sur, notre boutique de location de motos a été créée par des locaux humbles passionnés de motos et d'aventure.",
        body:
          "Ce qui a commencé comme une idée simple — aider les visiteurs à se déplacer librement — est devenu une entreprise de confiance pour des voyageurs du monde entier. Nous croyons que la meilleure façon de découvrir le Nicaragua est sur deux roues : sentir la brise de l'océan, explorer des plages cachées et vivre la beauté du pays sans limites. Notre mission a toujours été d'offrir un service amical, des motos fiables et des expériences inoubliables.",
        feat1Title: "Depuis 2017",
        feat1Body: "Plus de 8 ans de location à San Juan del Sur.",
        feat2Title: "Famille Locale",
        feat2Body: "Fondée par des locaux humbles de la région.",
        feat3Title: "Sans Limites",
        feat3Body: "Plages cachées, brise océanique, liberté totale.",
      },
      mission: {
        title: "Notre Mission",
        lead:
          "Offrir des locations de motos fiables, abordables et passionnantes à San Juan del Sur, aidant les voyageurs à explorer le Nicaragua avec liberté, confort et aventure depuis 2017.",
        v1Title: "Fiables",
        v1Body: "Motos soigneusement entretenues, vérifiées avant chaque location.",
        v2Title: "Abordables",
        v2Body: "Prix honnêtes et transparents, sans surprises.",
        v3Title: "Passionnantes",
        v3Body: "Aventures inoubliables sur la côte du Nicaragua.",
      },
      findus: { title: "Nous trouver", address: "San Juan del Sur, Rivas, Nicaragua", hours: "Lun – Dim · 7:00 – 19:00", directions: "Itinéraire" },
      contact: {
        title: "Contactez-nous",
        subtitle: "Prêt à rouler ? Réservez votre moto ou posez-nous une question.",
        name: "Nom", email: "Email", phone: "Téléphone / WhatsApp", moto: "Type de moto", start: "Date de début", end: "Date de fin", message: "Message",
        submit: "Envoyer", whatsappBtn: "Chat WhatsApp",
        success: "Réservation envoyée !", error: "Erreur. Essayez par WhatsApp.",
      },
      footer: { rights: "Tous droits réservés.", madeIn: "Fait avec ❤ à San Juan del Sur" },
    },
  },
  zh: {
    translation: {
      brand: "Cascante 摩托租赁",
      tagline: "圣胡安德尔苏尔 · 尼加拉瓜",
      nav: { home: "首页", about: "关于我们", rentals: "车型与价格", mission: "使命", findus: "位置", contact: "联系", bookNow: "立即预订" },
      hero: {
        eyebrow: "摩托租赁 · 135+ 评价 · 5 ★",
        typed: ["探索圣胡安德尔苏尔", "解锁冒险之旅", "两轮飞驰", "发现隐秘海滩"],
        subtitle: "可靠的摩托车、诚实的价格和本地经验。您在尼加拉瓜海岸的下一次旅程从这里开始。",
        bookNow: "立即预订", viewMotos: "查看车型", scroll: "向下滚动开始骑行",
      },
      proof: { reviews: "135+ 评价", rating: "Google 五星好评", years: "扎根圣胡安德尔苏尔", riders: "满意的骑手" },
      testimonials: { title: "骑手怎么说" },
      rentals: { title: "我们的摩托车", subtitle: "选择最适合您的冒险座驾。", perDay: "/ 天", perWeek: "/ 周", perMonth: "/ 月", bestFor: "适合", reserve: "预订", loading: "加载中…", featured: "精选车型", viewAll: "查看全部车型" },
      about: {
        title: "我们的故事",
        lead:
          "2017 年成立于圣胡安德尔苏尔，由怀抱摩托与冒险热情的本地朴实居民创立。",
        body:
          "最初的想法只是帮助游客更方便地出行，如今我们已成为来自世界各地旅行者信赖的租车伙伴。我们相信，探索尼加拉瓜最好的方式就是骑上两轮——感受海风，探访隐秘海滩，毫无束缚地体验这片土地的美。",
        feat1Title: "自 2017 年起",
        feat1Body: "在圣胡安德尔苏尔深耕 8 年以上。",
        feat2Title: "本地家庭",
        feat2Body: "由当地朴实居民创立和经营。",
        feat3Title: "毫无束缚",
        feat3Body: "隐秘海滩、海风、彻底自由。",
      },
      mission: {
        title: "我们的使命",
        lead:
          "自 2017 年起，在圣胡安德尔苏尔提供可靠、亲民、激动人心的摩托租赁，让旅行者以自由、舒适与冒险的方式探索尼加拉瓜。",
        v1Title: "可靠",
        v1Body: "每次出租前精心维护与检查。",
        v2Title: "亲民",
        v2Body: "价格诚信透明，绝无意外费用。",
        v3Title: "刺激",
        v3Body: "在尼加拉瓜海岸的难忘冒险。",
      },
      findus: { title: "找到我们", address: "San Juan del Sur, Rivas, Nicaragua", hours: "周一至周日 · 7:00 – 19:00", directions: "导航" },
      contact: {
        title: "联系我们", subtitle: "准备骑行了吗？立刻预订或随时咨询。",
        name: "姓名", email: "邮箱", phone: "电话 / WhatsApp", moto: "车型", start: "开始日期", end: "结束日期", message: "留言",
        submit: "发送预订", whatsappBtn: "WhatsApp 聊天",
        success: "预订已发送！", error: "出错了，请使用 WhatsApp。",
      },
      footer: { rights: "保留所有权利。", madeIn: "于圣胡安德尔苏尔用心打造 ❤" },
    },
  },
  de: {
    translation: {
      brand: "Cascante Moto Rental", tagline: "San Juan del Sur · Nicaragua",
      nav: { home: "Start", about: "Über uns", rentals: "Motorräder & Preise", mission: "Mission", findus: "Standort", contact: "Kontakt", bookNow: "Buchen" },
      hero: {
        eyebrow: "Motorradverleih · 135+ Bewertungen · 5 ★",
        typed: ["ENTDECKE SAN JUAN DEL SUR", "ABENTEUER STARTEN", "AUF ZWEI RÄDERN", "VERSTECKTE STRÄNDE"],
        subtitle: "Zuverlässige Bikes, faire Preise und lokales Wissen. Deine nächste Tour an Nicaraguas Küste startet hier.",
        bookNow: "Jetzt Buchen", viewMotos: "Motorräder", scroll: "Scrollen zum Fahren",
      },
      proof: { reviews: "135+ Bewertungen", rating: "5 Sterne bei Google", years: "Jahre in San Juan del Sur", riders: "Glückliche Fahrer" },
      testimonials: { title: "Was unsere Fahrer sagen" },
      rentals: { title: "Unsere Motorräder", subtitle: "Wähle dein perfektes Bike.", perDay: "/ Tag", perWeek: "/ Woche", perMonth: "/ Monat", bestFor: "Ideal für", reserve: "Reservieren", loading: "Lädt…", featured: "Top-Modell", viewAll: "Ganze Flotte ansehen" },
      about: {
        title: "Unsere Geschichte",
        lead:
          "Gegründet 2017 in San Juan del Sur — von bescheidenen Einheimischen mit tiefer Leidenschaft für Motorräder und Abenteuer.",
        body:
          "Was als einfache Idee begann — Reisenden zu mehr Bewegungsfreiheit zu verhelfen — ist heute ein vertrauensvolles Vermietgeschäft für Reisende aus aller Welt. Wir glauben, der beste Weg, Nicaragua zu entdecken, sind zwei Räder: Meeresbrise, versteckte Strände und grenzenlose Schönheit.",
        feat1Title: "Seit 2017",
        feat1Body: "Über 8 Jahre Vermietung in San Juan del Sur.",
        feat2Title: "Lokale Familie",
        feat2Body: "Von bescheidenen Einheimischen gegründet und geführt.",
        feat3Title: "Grenzenlos",
        feat3Body: "Versteckte Strände, Meeresbrise, totale Freiheit.",
      },
      mission: {
        title: "Unsere Mission",
        lead:
          "Zuverlässige, erschwingliche und aufregende Motorradvermietungen in San Juan del Sur — Reisenden seit 2017 ermöglichen, Nicaragua mit Freiheit, Komfort und Abenteuer zu erkunden.",
        v1Title: "Zuverlässig",
        v1Body: "Sorgfältig gewartete Motorräder, vor jeder Vermietung geprüft.",
        v2Title: "Erschwinglich",
        v2Body: "Ehrliche, transparente Preise — keine Überraschungen.",
        v3Title: "Aufregend",
        v3Body: "Unvergessliche Abenteuer entlang der Küste Nicaraguas.",
      },
      findus: { title: "Standort", address: "San Juan del Sur, Rivas, Nicaragua", hours: "Mo – So · 7:00 – 19:00", directions: "Route planen" },
      contact: {
        title: "Kontakt", subtitle: "Bereit loszufahren?",
        name: "Name", email: "E-Mail", phone: "Telefon / WhatsApp", moto: "Motorradtyp", start: "Startdatum", end: "Enddatum", message: "Nachricht",
        submit: "Buchung senden", whatsappBtn: "WhatsApp Chat",
        success: "Buchung gesendet!", error: "Fehler. Bitte WhatsApp nutzen.",
      },
      footer: { rights: "Alle Rechte vorbehalten.", madeIn: "Mit ❤ in San Juan del Sur" },
    },
  },
  it: {
    translation: {
      brand: "Cascante Moto Rental", tagline: "San Juan del Sur · Nicaragua",
      nav: { home: "Home", about: "Chi siamo", rentals: "Moto e Prezzi", mission: "Missione", findus: "Dove siamo", contact: "Contatti", bookNow: "Prenota" },
      hero: {
        eyebrow: "Noleggio moto · 135+ recensioni · 5 ★",
        typed: ["ESPLORA SAN JUAN DEL SUR", "VIVI L'AVVENTURA", "SU DUE RUOTE", "SCOPRI SPIAGGE NASCOSTE"],
        subtitle: "Moto affidabili, prezzi onesti e conoscenza locale. Il tuo prossimo viaggio sulla costa del Nicaragua inizia qui.",
        bookNow: "Prenota Ora", viewMotos: "Vedi Moto", scroll: "Scorri per partire",
      },
      proof: { reviews: "135+ recensioni", rating: "5 stelle su Google", years: "Anni a San Juan del Sur", riders: "Rider soddisfatti" },
      testimonials: { title: "Cosa dicono i nostri rider" },
      rentals: { title: "Le nostre moto", subtitle: "Scegli la moto perfetta.", perDay: "/ giorno", perWeek: "/ settimana", perMonth: "/ mese", bestFor: "Ideale per", reserve: "Prenota", loading: "Caricamento…", featured: "Moto in evidenza", viewAll: "Vedi tutta la flotta" },
      about: {
        title: "Chi siamo",
        lead: "Cascante Moto Rental nasce dall'amore per la libertà su due ruote e per il paradiso costiero di San Juan del Sur.",
        body: "Siamo una famiglia locale che noleggia moto curate a viaggiatori da tutto il mondo.",
        feat1Title: "Manutenzione Pro", feat1Body: "Ogni moto controllata prima di ogni noleggio.",
        feat2Title: "Conoscenza Locale", feat2Body: "Le migliori spiagge e percorsi nascosti.",
        feat3Title: "Supporto 24/7", feat3Body: "WhatsApp diretto sempre.",
      },
      mission: {
        title: "La nostra missione",
        lead: "Connettere i viaggiatori con il vero Nicaragua attraverso viaggi in moto sicuri e indimenticabili.",
        v1Title: "Avventura Responsabile", v1Body: "Cura per strade, spiagge e comunità.",
        v2Title: "Servizio Onesto", v2Body: "Prezzi chiari, nessuna sorpresa.",
        v3Title: "Comunità Locale", v3Body: "Sosteniamo attività e guide locali.",
      },
      findus: { title: "Dove siamo", address: "San Juan del Sur, Rivas, Nicaragua", hours: "Lun – Dom · 7:00 – 19:00", directions: "Indicazioni" },
      contact: {
        title: "Contattaci", subtitle: "Pronto a partire?",
        name: "Nome", email: "Email", phone: "Telefono / WhatsApp", moto: "Tipo moto", start: "Data inizio", end: "Data fine", message: "Messaggio",
        submit: "Invia prenotazione", whatsappBtn: "Chat WhatsApp",
        success: "Prenotazione inviata!", error: "Errore. Usa WhatsApp.",
      },
      footer: { rights: "Tutti i diritti riservati.", madeIn: "Fatto con ❤ a San Juan del Sur" },
    },
  },
  ru: {
    translation: {
      brand: "Cascante Moto Rental", tagline: "Сан-Хуан-дель-Сур · Никарагуа",
      nav: { home: "Главная", about: "О нас", rentals: "Мотоциклы и Цены", mission: "Миссия", findus: "Где мы", contact: "Контакты", bookNow: "Забронировать" },
      hero: {
        eyebrow: "Аренда мотоциклов · 135+ отзывов · 5 ★",
        typed: ["ИССЛЕДУЙ САН-ХУАН-ДЕЛЬ-СУР", "ОТКРОЙ ПРИКЛЮЧЕНИЕ", "НА ДВУХ КОЛЁСАХ", "СКРЫТЫЕ ПЛЯЖИ"],
        subtitle: "Надёжные мотоциклы, честные цены и местный опыт. Твоё следующее путешествие по побережью Никарагуа начинается здесь.",
        bookNow: "Забронировать", viewMotos: "Посмотреть мотоциклы", scroll: "Прокрути, чтобы поехать",
      },
      proof: { reviews: "135+ отзывов", rating: "5 звёзд в Google", years: "Лет в Сан-Хуан-дель-Сур", riders: "Довольных райдеров" },
      testimonials: { title: "Что говорят наши райдеры" },
      rentals: { title: "Наши мотоциклы", subtitle: "Выбери идеальный мотоцикл.", perDay: "/ день", perWeek: "/ неделя", perMonth: "/ месяц", bestFor: "Подходит для", reserve: "Забронировать", loading: "Загрузка…", featured: "Рекомендуем", viewAll: "Весь автопарк" },
      about: {
        title: "Наша история",
        lead:
          "Основан в 2017 году в Сан-Хуан-дель-Сур скромными местными жителями, страстно увлечёнными мотоциклами и приключениями.",
        body:
          "То, что начиналось как простая идея — помочь путешественникам передвигаться свободнее, — превратилось в надёжный прокат для гостей со всего мира. Мы верим, что лучший способ открыть Никарагуа — это на двух колёсах: чувствуя океанский бриз, исследуя скрытые пляжи и проживая красоту страны без границ.",
        feat1Title: "С 2017 года",
        feat1Body: "Более 8 лет проката в Сан-Хуан-дель-Сур.",
        feat2Title: "Местная семья",
        feat2Body: "Основан и работает скромными местными жителями.",
        feat3Title: "Без границ",
        feat3Body: "Скрытые пляжи, океанский бриз, полная свобода.",
      },
      mission: {
        title: "Наша миссия",
        lead:
          "Предоставлять надёжный, доступный и захватывающий прокат мотоциклов в Сан-Хуан-дель-Сур, помогая путешественникам исследовать Никарагуа со свободой, комфортом и приключениями с 2017 года.",
        v1Title: "Надёжно",
        v1Body: "Тщательно обслуживаемые мотоциклы, проверка перед каждой арендой.",
        v2Title: "Доступно",
        v2Body: "Честные, прозрачные цены — без сюрпризов.",
        v3Title: "Захватывающе",
        v3Body: "Незабываемые приключения по побережью Никарагуа.",
      },
      findus: { title: "Где мы", address: "San Juan del Sur, Rivas, Nicaragua", hours: "Пн – Вс · 7:00 – 19:00", directions: "Проложить маршрут" },
      contact: {
        title: "Связаться", subtitle: "Готов поехать? Бронируй или задавай вопросы.",
        name: "Имя", email: "Email", phone: "Телефон / WhatsApp", moto: "Тип мотоцикла", start: "Дата начала", end: "Дата окончания", message: "Сообщение",
        submit: "Отправить", whatsappBtn: "Чат WhatsApp",
        success: "Бронирование отправлено!", error: "Ошибка. Используйте WhatsApp.",
      },
      footer: { rights: "Все права защищены.", madeIn: "Сделано с ❤ в Сан-Хуан-дель-Сур" },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "es",
    supportedLngs: ["es", "en", "fr", "zh", "de", "it", "ru"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
